/*
 * Module for the Payroll Recipients widget
*/

rs.module("ui/controls/widgets/payrollrecipientswidget",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, chartApi) {

            var payrollSummary = $.js(jsSelectors.payrollSummary);

            $.js(jsSelectors.fundPicker).change(function () {

                $.js(jsSelectors.loadingSpinner).show();

                $.get(
                    backendUrls.getPayrollRecipientSummary,
                    {
                        fundKey: $(this).val()
                    }

                ).done(function (results) {

                    payrollSummary.js(jsSelectors.payrollHeader).html(results.PayrollHeader);
                    payrollSummary.js(jsSelectors.grossAmount).html(results.GrossAmount);
                    payrollSummary.js(jsSelectors.netAmount).html(results.NetAmount);

                    chartApi.updateChart(results.RecipientCounts);

                }).always(function () {

                    $.js(jsSelectors.loadingSpinner).hide();
                });
            }); 
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);